import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../../common/types';
import { SMLButton } from '../../../../components/primitives/SMLButton';
import type { CoverRedoDialogModel } from './useCoverRedoDialog';
import { coverRedoMessages as messages } from './coverRedoMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the cover redo; each part uses its own slice of it */
import styles from './CoverRedo.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * The footer of the dialog (b1, b2): the cost of the ticked groups against the credits left, Cancel
 * and the confirm. With a cost above the credits left the confirm is "Buy credits".
 */
const CoverRedoFooterComponent: React.FC<{ model: CoverRedoDialogModel }> = ({ model }) => {
  const intl = useIntl();
  const { credits, count, left, isShort } = model;
  let fine: string;
  if (isShort && left !== null) {
    fine = intl.formatMessage(messages.short, { left, more: credits - left });
  } else if (left === null) {
    fine = intl.formatMessage(messages.leftNoLimit);
  } else {
    fine = intl.formatMessage(messages.left, { left });
  }
  let label: string;
  if (isShort) {
    label = intl.formatMessage(messages.buyCredits);
  } else if (credits === 0) {
    label = intl.formatMessage(messages.redo, { count });
  } else {
    label = intl.formatMessage(messages.redoCost, { count, credits });
  }
  return (
    <div className={styles.footer}>
      <div className={styles.total}>
        <b>
          {credits === 0 ? intl.formatMessage(messages.groupFree) : intl.formatMessage(messages.credits, { credits })}
        </b>
        <small className={isShort ? styles.totalShort : undefined}>{fine}</small>
      </div>
      <SMLButton onClick={model.close} disabled={model.isStarting}>
        {intl.formatMessage(messages.cancel)}
      </SMLButton>
      <SMLButton
        variant="primary"
        onClick={model.confirm}
        disabled={model.state === undefined || count === 0 || model.isStarting}
      >
        {label}
      </SMLButton>
    </div>
  );
};

export const CoverRedoFooter = TypedMemo(CoverRedoFooterComponent);
